export const EXPORT_NAME_REGEX = /^[a-zA-Z0-9_\-.]+$/;
export const SPACE_FILTER_REGEX = /\s/g;

export const ExportValidation = {
  validateExportName: (name: string) => {
    if (!name || name.trim().length === 0) {
      return 'Export name is required';
    }

    if (name.length > 100) {
      return 'Export name must be 100 characters or less';
    }

    if (!EXPORT_NAME_REGEX.test(name)) {
      return 'Export name can only contain letters, numbers, underscores, hyphens, and periods';
    }

    return null;
  },
};
